import { USER_TYPE } from '../../utils/constants/user';
import { mapOrgUsersResponse } from '../../utils/orgUserOptionsUtils';

export type ConfigApiOption = {
    label: string;
    value: string;
    /** Muted detail rendered on the right of the option row, opposite the label. */
    secondaryLabel?: string;
    /** Listed but refused at selection, because this row is not usable as a value. */
    disabled?: boolean;
    /** The response row this option was shaped from, attached where the endpoint offers a fix for it. */
    sourceRow?: any;
};

export type ConfigApiContext = {
    /** The organisation this drawer instance is acting on, not the logged-in user's own. */
    orgId?: string;
    accountType?: string;
    aggregatorId?: string;
};

export type ConfigApiRequest = {
    params: Record<string, any>;
    /** Set only where the generic response reader cannot produce this endpoint's options. */
    mapResponse?: (responseBody: any) => ConfigApiOption[];
    /**
     * Account type to create a user as, where this endpoint's list can be extended in place. Set
     * means the dropdown offers adding a user to the organisation the request named.
     */
    addUserAccountType?: string;
};

/** config.api identifiers that need request shaping beyond the aggregator-scoped default. */
export const CONFIG_API = {
    AICA_GET_ORG_USERS: 'AICA_GET_ORG_USERS',
};

/**
 * How a config.api dropdown asks for its options, defaulting to the aggregator-scoped request and
 * generic response reading that every existing one (products, lenders, cities, pincodes) uses.
 *
 * AICA_GET_ORG_USERS is the one special case: users of ONE organisation, so its request is that
 * organisation rather than the caller's aggregator.
 */
export const resolveConfigApiRequest = (api: string, context: ConfigApiContext): ConfigApiRequest => {
    switch (api) {
        case CONFIG_API.AICA_GET_ORG_USERS:
            return {
                params: { orgId: context.orgId, accountType: context.accountType },
                mapResponse: mapOrgUsersResponse,
                // A user of a partner organisation. aica keys that org's user list on partnerOrgId,
                // which only the PARTNER account type sets — any other type would create a user the
                // list never returns, which reads exactly like a broken refetch.
                addUserAccountType: USER_TYPE.PARTNER,
            };
        default:
            return { params: { aggregatorId: context.aggregatorId } };
    }
};
